import { Key, useEffect, useState } from 'react';
import { wdiCore, WdiModalAppProps } from '@/components/WdiControls';
import { EC } from '@/services/mdm/ec';
import { RebateInfo } from '@/services/sales/rebateinfo';
import { WdiModal } from '@/components/WdiControls/WdiModalForm';
import { ButtonColumn, FilterColumn, GridFilterForm } from '@/components/GridWidget/GridFilterForm';
import { Button, DatePicker, message } from 'antd';
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { WdiSelect } from '@/components/WdiControls/WdiSelect';
import { SorterResult } from 'antd/lib/table/interface';
import moment from 'moment';
import { WdiTable } from '@/components/WdiControls/WdiTable';
import { formatter, ResponseStatus } from '@/utils/request';
import { CustSys } from '@/services/mdm/custsys';
import { PageType } from '@/services/basic/pagetype';
import download from '@/utils/download';
import { DataOptions } from '@/services/basic/metadata';
import { VatType } from '@/services/mdm/vattype';
import { SoldTo } from "@/services/mdm/soldto";
import { Staff } from '@/services/basic/staff';

const { RangePicker } = DatePicker;

type TableParams = {
  pagination: TablePaginationConfig;
  sorter?: SorterResult<any> | null | undefined;
  filterOptions: any,
}

const isOfficialStatus = [
  { label: '计划', value: 'N' }
  , { label: '正式', value: 'Y' }
];

const RebateInfoSelectApp: React.FC<WdiModalAppProps> = (props) => {

  const [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      defaultPageSize: 10,
      total: 0,
      showTotal: (total) => {
        return `共 ${total} 条`;
      },
    },
    sorter: null,
    filterOptions: null,
  });
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [currentFilterOptions, setCurrentFilterOptions] = useState<any>(null);

  const buttonColumns: ButtonColumn[] = [
    {
      title: '导出',
      key: 'Export',
      doClick: (filterOptions: any) => {
        let filter = getFilterOptions(Object.assign({}, tableParams, { filterOptions }));
        const req: API.QueryForPageReq = {
          filterOptions: JSON.stringify(filter),
          pagenum: 0,
          pagesize: 0
        };

        download(RebateInfo.Path.DownLoadRebateInfoPicker, formatter({
          method: 'POST',
          body: {
            ...req
          },
        }))
      }
    },
  ]
  const filterColumns: FilterColumn[] = [
    {
      title: '单据类型',
      dataIndex: 'pageTypeId',
      span: 4,
      render: () => {
        return (
          <WdiSelect {...{
            mode: "multiple",
            allowClear: true,
            placeholder: "请选择单据类型",
            showSearch: true,
            dataLoading: async (params) => {
              const response = await PageType.search(Object.assign({
                pageTypeIds: [1201, 1202, 1203, 1204, 1205].join()
              }, params));


              return response.data.map((item) => {
                return { value: item.pageTypeId, label: item.pageTypeName };
              });
            }
          }} />
        )
      },
    },
    {
      title: '客户集团',
      dataIndex: 'custSysCode',
      span: 4,
      render: () => {
        return (
          <WdiSelect {...{
            mode: "multiple",
            allowClear: true,
            placeholder: "请选择客户集团",
            showSearch: true,
            remote: true,
            dataLoading: async (params) => {
              const response = await CustSys.ajaxSearch(Object.assign({}, params));
              return response.data.map((item) => {
                return { value: item.custSysCode, label: item.codeOrName };
              });
            }
          }} />
        )
      },
    },
    {
      title: '销售月份',
      dataIndex: 'speriod',
      span: 6,
      render: () => {
        return <RangePicker picker="month" style={{ width: '100%' }} allowEmpty={[true, true]} />
      }
    },
    {
      title: '费用项',
      dataIndex: 'ecId',
      span: 6,
      render: () => {
        return (
          <WdiSelect {...{
            mode: "multiple",
            allowClear: true,
            placeholder: "请选择费用项",
            showSearch: true,
            dataLoading: async (params) => {
              const response = await EC.searchEc3(Object.assign({
                pageTypeIds: [4601, 4602, 4603, 4604, 4605].join()
              }, params));

              return response.data.map((item) => {
                return { value: item.ecId, label: item.ecName };
              });
            }
          }} />
        )
      },
    },
    {
      title: '返利核销单已审批人',
      dataIndex: 'approverUserIds',
      span: 4,
      render: () => {
        return (
          <WdiSelect {...{
            allowClear: true,
            placeholder: "请选择已审批人",
            showSearch: true,
            remote: true,
            mode: "multiple",
            dataLoading: async (params) => {
              const response = await Staff.ajaxSearch(Object.assign({}, params));
              return response.data.map((item) => {
                return { value: item.staffId, label: item.staffName };
              });
            }
          }} />
        )
      },
    },
    {
      title: '支付方式',
      dataIndex: 'paymentMethodId',
      span: 4,
      render: () => {
        return (
          <WdiSelect {...{
            allowClear: true,
            placeholder: "请选择支付方式",
            showSearch: true,
            dataLoading: async (params) => {
              const response = await DataOptions.search({ typeGroup: 5 });
              return response.data.map((item) => {
                return { value: item.value, label: item.name };
              });
            }
          }} />
        )
      }
    },
    {
      title: '税率类型',
      dataIndex: 'vatTypeId',
      span: 4,
      render: () => {
        return (
          <WdiSelect {...{
            allowClear: true,
            placeholder: "请选择税率类型",
            showSearch: true,
            dataLoading: async (params) => {
              const response = await VatType.search({});
              return response.data.map((item) => {
                return { value: item.vatTypeId, label: item.vatTypeName };
              });
            }
          }} />
        )
      }
    },
    {
      title: '发票类型',
      dataIndex: 'invoiceType',
      span: 6,
      render: () => {
        return (
          <WdiSelect {...{
            allowClear: true,
            placeholder: "请选择发票类型",
            showSearch: true,
            dataLoading: async (params) => {
              const response = await DataOptions.search({ typeGroup: 106 });
              return response.data.map((item) => {
                return { value: item.value, label: item.name };
              });
            }
          }} />
        )
      },
    },
    {
      title: '售达方',
      dataIndex: 'soldToCode',
      span: 6,
      render: () => {
        return (
          <WdiSelect {...{
            allowClear: true,
            placeholder: "请选择售达方",
            showSearch: true,
            remote: true,
            dataLoading: async (params) => {
              const response = await SoldTo.ajaxSearch(Object.assign({}, params));
              return response.data.map((item) => {
                return { value: item.soldToCode, label: item.codeOrName };
              });
            }
          }} />
        )
      },
    },
    {
      title: '计划/正式合同',
      dataIndex: 'isOfficial',
      span: 4,
      render: () => {
        return (
          <WdiSelect {...{
            allowClear: true,
            placeholder: "请选择合同类型",
            showSearch: true,
            dataLoading: async (params) => {
              return isOfficialStatus.map((item) => {
                return { value: item.value, label: item.label };
              });
            }
          }} />
        )
      },
    },
    {
      title: '合同状态',
      dataIndex: 'contractStatusId',
      span: 4,
      render: () => {
        return (
          <WdiSelect {...{
            allowClear: true,
            placeholder: "请选择合同状态",
            showSearch: true,
            dataLoading: async (params) => {
              const response = await DataOptions.search({ typeGroup: 107 });
              return response.data.map((item) => {
                return { value: item.value, label: item.name };
              });
            }
          }} />
        )
      },
    }
  ];
  const columns: ColumnsType<any> = [
    {
      title: '返利单编号',
      width: 80,
      dataIndex: 'rebateInfoId',
      ellipsis: true,
    },
    {
      title: '售达方',
      width: 120,
      dataIndex: 'soldToCode',
      ellipsis: true,
      render: (_, record) => (
        wdiCore.String.CodeOrName(record.soldToCode, record.soldToName)
      ),
    },
    {
      title: '售达方主户',
      width: 120,
      dataIndex: 'soldToMasterCode',
      ellipsis: true,
      render: (_, record) => (
        wdiCore.String.CodeOrName(record.soldToMasterCode, record.soldToMasterName)
      ),
    },
    {
      title: '客户集团',
      width: 120,
      dataIndex: 'custSysCode',
      ellipsis: true,
      render: (_, record) => (
        wdiCore.String.CodeOrName(record.custSysCode, record.custSysName)
      ),
    },
    {
      title: '服务商',
      width: 120,
      dataIndex: 'soldToCode',
      ellipsis: true,
      render: (_, record) => (
        wdiCore.String.CodeOrName(record.soldToCodeService, record.soldToNameService)
      ),
    },
    {
      title: '供货售达方',
      width: 120,
      dataIndex: 'soldToCode',
      ellipsis: true,
      render: (_, record) => (
        wdiCore.String.CodeOrName(record.soldToCodeSupply, record.soldToNameSupply)
      ),
    },
    {
      title: '门店',
      width: 120,
      dataIndex: 'shopId',
      ellipsis: true,
      render: (_, record) => (
        wdiCore.String.CodeOrName(record.shopCode, record.shopName)
      ),
    },
    {
      title: '费用项',
      width: 100,
      dataIndex: 'ecId',
      ellipsis: true,
      render: (_, record) => (
        record.ecName
      ),
    },
    {
      title: '产品线',
      width: 100,
      dataIndex: 'productLineId',
      ellipsis: true,
      render: (_, record) => (
        wdiCore.String.CodeOrName(record.productLineCode, record.productLineName)
      ),
    },
    {
      title: '销售月份',
      width: 60,
      dataIndex: 'speriod',
      ellipsis: true,
    },
    {
      title: '实际销售额',
      dataIndex: 'revSoldTo',
      width: 80,
      ellipsis: true,
    },
    {
      title: '结案金额',
      width: 60,
      dataIndex: 'amountSs',
      ellipsis: true,
      render: (_, record) => (
        wdiCore.Number.AmountToString(record.amountSs, 2)
      ),
    },
    {
      title: '核销金额',
      width: 80,
      dataIndex: 'amountRs',
      ellipsis: true,
      render: (_, record) => (
        wdiCore.Number.AmountToString(record.amountRs, 2)
      ),
    },
    {
      title: '支付方式',
      width: 80,
      dataIndex: 'paymentMethodName',
      ellipsis: true,
    },
    {
      title: '发票类型',
      width: 80,
      dataIndex: 'invoiceTypeName',
      ellipsis: true,
    },
    {
      title: '税率类型',
      width: 80,
      dataIndex: 'vatTypeName',
      ellipsis: true,
    }
  ];

  useEffect(() => {
    fetchData(Object.assign({}, tableParams));
  }, []);

  const getFilterOptions = (params: TableParams) => {
    const filterOptions: any = {};

    if (params.filterOptions) {
      const {
        speriod,
        ecId,
        custSysCode,
        pageTypeId,
        approverUserIds,
        paymentMethodId,
        vatTypeId,
        invoiceType,
        soldToCode,
        isOfficial,
        contractStatusId
      } = params.filterOptions;
      if (!wdiCore.Object.IsNullOrUndefined(speriod)) {
        if (!wdiCore.Object.IsNullOrUndefined(speriod[0])) {
          filterOptions.startDate = moment(speriod[0]).format('YYYYMM');
        }
        if (!wdiCore.Object.IsNullOrUndefined(speriod[1])) {
          filterOptions.endDate = moment(speriod[1]).format('YYYYMM');
        }
      }
      if (!wdiCore.Object.IsNullOrUndefined(pageTypeId) && pageTypeId.length > 0) {
        filterOptions.pageTypeId = pageTypeId.join();
      }
      if (!wdiCore.Object.IsNullOrUndefined(ecId) && ecId.length > 0) {
        filterOptions.ecId = ecId.join();
      }
      if (!wdiCore.Object.IsNullOrUndefined(custSysCode) && custSysCode.length > 0) {
        filterOptions.custSysCode = custSysCode.join();
      }
      if (!wdiCore.Object.IsNullOrUndefined(approverUserIds)) {
        filterOptions.approverUserIds = approverUserIds.join();
      }
      if (!wdiCore.Object.IsNullOrUndefined(paymentMethodId)) {
        filterOptions.paymentMethodId = paymentMethodId;
      }
      if (!wdiCore.Object.IsNullOrUndefined(vatTypeId)) {
        filterOptions.vatTypeId = vatTypeId;
      }
      if (!wdiCore.Object.IsNullOrUndefined(invoiceType)) {
        filterOptions.invoiceType = invoiceType;
      }
      if (!wdiCore.Object.IsNullOrUndefined(soldToCode)) {
        filterOptions.soldToCode = soldToCode;
      }
      if (!wdiCore.Object.IsNullOrUndefined(isOfficial)) {
        filterOptions.isOfficial = isOfficial;
      }
      if (!wdiCore.Object.IsNullOrUndefined(contractStatusId)) {
        filterOptions.contractStatusId = contractStatusId;
      }
    }

    return filterOptions;
  }

  const fetchData = (params: TableParams) => {
    setLoading(true);
    const filterOptions = getFilterOptions(params);
    const req: API.QueryForPageReq = {
      filterOptions: JSON.stringify(filterOptions),
      pagenum: params.pagination.current ? (params.pagination.current - 1) : 0,
      pagesize: params.pagination.pageSize ? params.pagination.pageSize : 10,
    };

    setCurrentFilterOptions(filterOptions);

    RebateInfo.queryPaymentForSelect(req).then(responseResult => {
      const data = responseResult.data;
      if (data) {
        setDataSource(data.records);
        setTableParams({
          pagination: {
            ...params.pagination,
            total: data.totalCount,
          },
          sorter: params.sorter,
          filterOptions: params.filterOptions
        });
        setLoading(false);
        setSelectedRowKeys([]);
      }
    });
  };
  const doSearch = (filterOptions: any) => {
    fetchData(Object.assign({}, tableParams, { filterOptions }));
  }

  const onSelectChange = (newSelectedRowKeys: Key[], newSelectedRows: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(newSelectedRows);
  };
  return (
    <WdiModal
      title={props.title}
      visible={props.visible}
      width={1400}
      footer={
        <>
          <Button onClick={() => {
            props.onClose ? props.onClose() : null
          }}>
            取消
          </Button>
          <Button onClick={() => {
            if (selectedRows.length == 0) {
              message.error('请至少选择一条数据');
            } else {
              props.onSave?.({
                code: ResponseStatus.SUCCESS,
                data: selectedRows
              })
            }
          }}>
            添加
          </Button>
          <Button onClick={(filterOptions: any) => {
            let filter = getFilterOptions(Object.assign({}, tableParams, { currentFilterOptions }));

            const req: API.QueryForPageReq = {
              filterOptions: JSON.stringify(filter),
              pagenum: 0,
              pagesize: 0
            };

            RebateInfo.queryPaymentForSelect(req).then(response => {
              props.onSave?.({
                code: ResponseStatus.SUCCESS,
                data: response.data.records
              })
            });
          }}>
            全部添加
          </Button>
        </>
      }
      onCancel={() => {
        props.onClose ? props.onClose() : null
      }}
      onOk={() => {
        if (selectedRows.length == 0) {
          message.error('请至少选择一条数据');
        } else {
          props.onSave?.({
            code: ResponseStatus.SUCCESS,
            data: selectedRows
          })
        }
      }}
    >
      <GridFilterForm doSeach={doSearch} columns={filterColumns} buttonColumns={buttonColumns} />
      <WdiTable
        showPageRows={10}
        rowSelection={{ selectedRowKeys, onChange: onSelectChange }}
        columns={columns}
        size='small'
        dataSource={dataSource}
        pagination={{
          ...tableParams.pagination,
          onChange: (page, pageSize) => {
            fetchData(Object.assign({}, tableParams, {
              pagination: {
                ...tableParams.pagination,
                current: page,
                pageSize: pageSize
              }
            }))
          }
        }}
        loading={loading}
      />
    </WdiModal>
  );
};
export default RebateInfoSelectApp;
